(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sleek-menu-drawer"] && !Shopify.designMode) return;
  try {
    const ANIM_DURATION = 300;
  const ANIM_EASING = 'cubic-bezier(0.25, 0.46, 0.45, 0.94)';

  class SleekMenuDrawer extends HTMLElement {
    connectedCallback() {
      if (this.classList.contains('sleek-menu-drawer--cascade')) {
        this.querySelectorAll('.sleek-menu-drawer__details > summary').forEach((summary) => {
          summary.addEventListener('click', this.#onSummaryClick);
        });
      }
      this.querySelectorAll('.sleek-menu-drawer__mega-l2 > summary').forEach((summary) => {
        summary.addEventListener('click', this.#onMegaL2Click);
      });
    }

    disconnectedCallback() {
      this.querySelectorAll('.sleek-menu-drawer__details > summary').forEach((summary) => {
        summary.removeEventListener('click', this.#onSummaryClick);
      });
      this.querySelectorAll('.sleek-menu-drawer__mega-l2 > summary').forEach((summary) => {
        summary.removeEventListener('click', this.#onMegaL2Click);
      });
    }

    #onSummaryClick = (event) => {
      event.preventDefault();
      const summary = event.currentTarget;
      const details = summary.closest('details');
      const submenu = details.querySelector(':scope > .menu-drawer__submenu');
      if (!submenu) return;
      this.#animateHeight(
        submenu,
        details.classList.contains('menu-open'),
        () => {
          if (!details.open) details.open = true;
          details.classList.add('menu-open');
          summary.setAttribute('aria-expanded', 'true');
        },
        () => {
          details.classList.remove('menu-open');
          summary.setAttribute('aria-expanded', 'false');
        }
      );
    };

    #onMegaL2Click = (event) => {
      event.preventDefault();
      const details = event.currentTarget.closest('.sleek-menu-drawer__mega-l2');
      const content = details.querySelector(':scope > .sleek-menu-drawer__mega-l2-content');
      if (!content) return;
      this.#animateHeight(
        content,
        details.open,
        () => { details.open = true; },
        () => { details.open = false; }
      );
    };

    #animateHeight(el, isOpen, openFn, closeFn) {
      el.getAnimations().forEach((a) => a.cancel());
      if (isOpen) {
        const h = el.getBoundingClientRect().height;
        closeFn();
        el.animate([{ height: h + 'px' }, { height: '0px' }], {
          duration: ANIM_DURATION, easing: ANIM_EASING,
        }).onfinish = () => { el.style.height = '0px'; };
      } else {
        openFn();
        el.getBoundingClientRect(); // force reflow
        el.style.height = '0px';
        el.animate([{ height: '0px' }, { height: el.scrollHeight + 'px' }], {
          duration: ANIM_DURATION, easing: ANIM_EASING,
        }).onfinish = () => { el.style.height = 'auto'; };
      }
    }
  }

  if (!customElements.get('sleek-menu-drawer')) {
    customElements.define('sleek-menu-drawer', SleekMenuDrawer);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["valor-cart-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
  /* Shared overlay — same singleton as valor-menu-drawer; whichever loads first creates it */
  function _getValorOverlay() {
    if (window.__valorDrawerOverlay) return window.__valorDrawerOverlay;
    const el = document.createElement('div');
    el.className = 'valor-drawer-overlay';
    document.body.appendChild(el);
    const ov = {
      el,
      _handler: null,
      show(onClose) {
        el.classList.add('valor-open');
        if (this._handler) el.removeEventListener('click', this._handler);
        this._handler = () => { this.hide(); onClose && onClose(); };
        el.addEventListener('click', this._handler, { once: true });
      },
      hide() {
        el.classList.remove('valor-open');
        if (this._handler) { el.removeEventListener('click', this._handler); this._handler = null; }
      },
    };
    return (window.__valorDrawerOverlay = ov);
  }

  function _removeBlindDropFees(cart) {
    if (window.__valorBlindDropCleanup) return window.__valorBlindDropCleanup;

    window.__valorBlindDropCleanup = (async () => {
      const currentCart = cart || await fetch('/cart.js', {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      }).then((response) => {
        if (!response.ok) throw new Error(`Unable to load cart (${response.status})`);
        return response.json();
      });
      const feeLines = (currentCart.items || []).filter(
        (item) => item.handle === 'blind-drop-handling-fee'
      );

      if (!feeLines.length) {
        return { cart: currentCart, removed: false, hasFee: false };
      }

      const updates = {};
      feeLines.forEach((item) => { updates[item.key] = 0; });
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ updates }),
      });
      if (!response.ok) throw new Error(`Unable to remove Blind Drop fee (${response.status})`);
      const updatedCart = await response.json();

      // `removed` drives a page reload, so it has to describe what actually
      // happened rather than what we asked for. Reporting success just because
      // fee lines were FOUND turned an un-removable fee into an infinite reload:
      // every load saw the fee, POSTed the removal, reported removed=true and
      // reloaded into exactly the same state. Confirm against the cart the
      // update returned, and if the fee survived, leave it alone and let the
      // page render — a visible stray fee beats a cart nobody can load.
      const feeSurvived = (updatedCart.items || []).some(
        (item) => item.handle === 'blind-drop-handling-fee'
      );
      if (feeSurvived) {
        console.warn('[ValorCartDrawer] Blind Drop fee could not be removed; leaving it in place', updatedCart.items.filter((i) => i.handle === 'blind-drop-handling-fee'));
      }
      return { cart: updatedCart, removed: !feeSurvived, hasFee: feeSurvived };
    })().finally(() => { window.__valorBlindDropCleanup = null; });

    return window.__valorBlindDropCleanup;
  }

  // ── Multi-location quantity restore ──────────────────
  // valor-cart's delivery-location step scales the server cart to base x
  // (number of selected locations) because checkout needs one full copy per
  // location. That is a checkout-only state, so the drawer — which is rendered
  // on every page — must not show or let the buyer edit those inflated numbers
  // either. `_scaled` carries the pre-scale quantity per line item key.
  //
  // Memoized on a shared global rather than per-caller: the drawer is present on
  // /cart alongside valor-cart, and both run this during their connectedCallback.
  // The memo is deliberately never cleared — one restore per page load is
  // correct, and a second pass over a stale cart snapshot would re-POST the same
  // quantities and report a spurious change.
  //
  // NOTE: kept in sync with vcRestoreScaledCart in sections/valor-cart.liquid.
  function _restoreScaledCart(cart) {
    if (window.__valorScaledCartRestore) return window.__valorScaledCartRestore;

    window.__valorScaledCartRestore = (async () => {
      let marker = null;
      try {
        const raw = cart?.attributes?._scaled;
        if (raw) marker = JSON.parse(String(raw).replace(/&quot;/g, '"'));
      } catch (_) {}
      if (!marker) return { restored: false, cart };

      // Current markers are keyed by variant id. `lines` is the older shape,
      // keyed by line item key — still honoured so a cart mid-flow when this
      // deployed is not stranded at inflated quantities.
      const byVariant = marker.items || null;
      const byKey     = marker.lines || null;
      if (!byVariant && !byKey) return { restored: false, cart };

      const n = parseInt(marker.n, 10) || 0;
      const updates = {};
      let matched = 0;
      (cart.items || []).forEach((item) => {
        const rawBase = byVariant ? byVariant[String(item.variant_id)] : byKey[item.key];
        const base = parseInt(rawBase, 10);
        if (!base || base <= 0 || n <= 1) return;
        matched++;
        // Anything added since the scale sits on top of it, so carry the delta
        // over. A line below base x n was changed by something we don't own —
        // an inventory clamp, an edit elsewhere — so leave it alone.
        const delta = item.quantity - base * n;
        if (delta < 0 || base + delta === item.quantity) return;
        updates[item.key] = base + delta;
      });

      // Only retire the marker once it has been acted on. Clearing it after
      // matching nothing is what turned a stale marker into a permanent
      // failure: the inflated cart stayed inflated with no second attempt.
      // Bounded, though: a marker that has missed three separate page loads is
      // never going to match, and an immortal one means data-vc-scaled hides the
      // cart figures on every load forever. Count the misses in the marker itself
      // so the count survives the page loads it is counting.
      if (!matched && (cart.items || []).length) {
        const tries = (parseInt(marker.tries, 10) || 0) + 1;
        const giveUp = tries >= 3;
        console.warn(`[ValorCartDrawer] _scaled matched no cart line (attempt ${tries}); ${giveUp ? 'retiring it' : 'leaving it in place to retry'}`, marker);
        try {
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({
              attributes: giveUp
                ? { _scaled: '', _lineitems: '' }
                : { _scaled: JSON.stringify(Object.assign({}, marker, { tries })) },
            }),
          });
        } catch (error) {
          console.error('[ValorCartDrawer] Could not update the _scaled marker', error);
        }
        return { restored: false, cart };
      }

      const body = { attributes: { _scaled: '', _lineitems: '' } };
      if (Object.keys(updates).length) body.updates = updates;

      try {
        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(body),
        });
        if (!response.ok) throw new Error(`Unable to restore cart quantities (${response.status})`);
        return { restored: !!body.updates, cart: await response.json() };
      } catch (error) {
        console.error('[ValorCartDrawer] Multi-location quantity restore failed', error);
        return { restored: false, cart };
      }
    })();

    return window.__valorScaledCartRestore;
  }

  class ValorCartDrawer extends HTMLElement {
    async connectedCallback() {
      this._freeShippingCents = parseInt(this.dataset.freeShippingCents || '0', 10);
      this._lowStock = parseInt(this.dataset.lowStock || '0', 10);
      // B2B lock: server renders the drawer as an empty greyed cart; never
      // rebuild it from /cart.js or the hidden contents would reappear.
      this._locked = this.hasAttribute('data-vcd-locked');
      // Keep direct checkout unavailable to B2B customers. They must use the
      // full cart's delivery-location step before entering checkout.
      this._initCricket();
      if (!this._locked) {
        try {
          const result = await _removeBlindDropFees();
          // Unscale before the first render, so the inflated multi-location
          // quantities never reach the DOM. No reload needed here — unlike the
          // cart page, _rebuildItems renders from the cart JSON.
          const restore = await _restoreScaledCart(result.cart);
          this._rebuildItems(restore.cart);
          this._applyCart(restore.cart);
        } catch (error) {
          console.error('[ValorCartDrawer] Blind Drop cleanup failed', error);
        }
      }
      this._bindEvents();
      this._initStoreCredit();
      // Listen for theme cart update events (add-to-cart from product page, etc.)
      document.addEventListener('cart:update', this._onThemeCartUpdate.bind(this));
    }

    _initCricket() {
      const btn = this.querySelector('.vcd-checkout-btn');
      if (!btn || !window.__vaCustomerInfo) return;

      // Liquid already hides this for B2B. Enforce the gate again in JavaScript
      // in case the drawer markup is refreshed without a full page load.
      btn.style.display = 'none';
    }

    _initStoreCredit() {
      if (!window.__vaCustomerInfo || !window.__vaAuth) return;
      const self = this;
      window.__vaCustomerInfo.then(function(data) {
        if (!data) return;
        const market = (data.shopifyMarketHandle || data.ShopifyMarketHandle || '').toUpperCase();
        if (market !== 'CRICKET-WIRELESS') return;
        if ((data.No || data.no || '') !== 'C0000105') return;

        const auth = window.__vaAuth;
        fetch('/cart.js')
          .then(r => r.json())
          .then(cart => {
            const body = { action: 'store-credit-quote', customer_id: auth.customer_id, ts: auth.ts, token: auth.token, shop: Shopify.shop };
            if (cart) body.order_total = (cart.total_price / 100).toFixed(2);
            return fetch(auth.proxy, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) }).then(r => r.json());
          })
          .then(function(res) {
            if (!res?.ok || !res.data) return;
            const sc = res.data;
            const fmt = v => '$' + parseFloat(v).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            const band    = self.querySelector('#vcd-sbk-band');
            const availEl = band && band.querySelector('[data-vcd-sbk-avail]');
            const maxEl   = band && band.querySelector('[data-vcd-sbk-max]');
            if (availEl) availEl.textContent = fmt(sc.available);
            if (maxEl)   maxEl.textContent   = fmt(sc.maxApplicable);
            if (band)    band.style.display  = '';
          })
          .catch(() => {});
      });
    }

    disconnectedCallback() {
      document.removeEventListener('cart:update', this._onThemeCartUpdate.bind(this));
    }

    /* ===== Open / Close ===== */
    open() {
      this.classList.add('vcd-open');
      document.body.classList.add('vcd-scroll-locked');
      _getValorOverlay().show(() => this.close());
      const panel = this.querySelector('[data-vcd-panel]');
      if (panel) setTimeout(() => panel.focus(), 280);
    }

    close() {
      this.classList.remove('vcd-open');
      document.body.classList.remove('vcd-scroll-locked');
      _getValorOverlay().hide();
      const trigger = document.querySelector('[data-vcd-open]');
      if (trigger) trigger.focus();
    }

    /* ===== Events ===== */
    _bindEvents() {
      // Open via custom event dispatched by trigger button in header
      document.addEventListener('vcd:open-cart', () => this.open());

      // Close button
      this.querySelector('[data-vcd-close]')?.addEventListener('click', () => this.close());

      // Single-address checkout — write a single-entry _order so order processing
      // has the BC customer info even without the distribution component.
      const checkoutBtn = this.querySelector('.vcd-checkout-btn[href]');
      if (checkoutBtn) {
        checkoutBtn.addEventListener('click', async (e) => {
          e.preventDefault();
          if (checkoutBtn.hasAttribute('data-min-order')) return;
          const href = checkoutBtn.href;
          checkoutBtn.dataset.loading = '';
          try {
            const [customerData, cartRes, erpAddresses] = await Promise.all([
              window.__vaCustomerInfo,
              fetch('/cart.js'),
              window.__vaGetErpAddresses ? window.__vaGetErpAddresses() : Promise.resolve(null),
            ]);
            const shipTo = customerData?.defaultShipTo || null;
            const cart  = cartRes.ok ? await cartRes.json() : null;
            const erpNo = customerData?.No || customerData?.no || '';
            if (!erpNo) { window.location.href = href; return; }

            const items = {};
            if (cart?.items?.length) {
              for (const item of cart.items) {
                const vid = String(item.variant_id);
                items[vid] = (items[vid] || 0) + item.quantity;
              }
            }
            const attrs = {
              _address_type: JSON.stringify({
                type: Array.isArray(erpAddresses) && erpAddresses.length > 0
                  ? (erpAddresses.length === 1 ? 'single' : 'multiple')
                  : 'unknown',
                company_location_id: window.__vaCurrentCompanyLocationId || '',
                bc_customer: erpNo,
                address_count: Array.isArray(erpAddresses) ? erpAddresses.length : null,
              }),
              _order: JSON.stringify([{
                id:          shipTo?.systemId   || '',
                bc_customer: shipTo?.customerNo || '',
                bc_ship_to:  shipTo?.code       || '',
                addr:        shipTo?.addr       || '',
                contact:     { name: shipTo?.contact || '', phone: shipTo?.phoneNo || '' },
                items,
              }]),
              _address: JSON.stringify([{
                id:                	shipTo?.systemId          || '',
                bc_customer:       	shipTo?.customerNo        || '',
                bc_ship_to:        	shipTo?.code              || '',
                company:           	shipTo?.company           || '',
                address:           	shipTo?.address           || '',
                address2:          	shipTo?.address2          || '',
                city:              	shipTo?.city              || '',
                contact:           	shipTo?.contact           || '',
                phone:           	shipTo?.phoneNo           || '',
                country: 			shipTo?.countryRegionCode || '',
                zip:          		shipTo?.postCode          || '',
                state:             	shipTo?.state             || '',
              }]),
              _lineitems: '',
            };

            const _auth = window.__vaAuth;
            const variantKey = cart ? cart.items
              .map(i => `${i.variant_id}:${i.quantity}`).sort().join(',') : '';
            await Promise.all([
              fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ attributes: attrs }),
              }),
              (_auth && variantKey) ? fetch(_auth.proxy, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ action: 'clear-shipping-total', customer_id: _auth.customer_id, ts: _auth.ts, token: _auth.token, shop: Shopify.shop, variant_key: variantKey }),
              }).catch(() => {}) : Promise.resolve(),
            ]);
          } catch (_) {}
          window.location.href = href;
        });
      }

      // Escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.classList.contains('vcd-open')) this.close();
      });

      // Qty steppers
      this.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-vcd-step]');
        if (!btn) return;
        const itemEl = btn.closest('[data-vcd-item]');
        if (!itemEl) return;
        const input = itemEl.querySelector('[data-vcd-qty]');
        if (!input) return;
        const step = parseInt(btn.getAttribute('data-vcd-step'), 10);
        const next = Math.max(0, parseInt(input.value || '0', 10) + step);
        input.value = next;
        this._changeQty(itemEl, next);
      });

      // Cart note toggle
      this.addEventListener('click', (e) => {
        const toggle = e.target.closest('[data-vcd-note-toggle]');
        if (!toggle) return;
        const wrap = toggle.closest('.vcd-note-wrap');
        wrap.classList.toggle('is-open');
        if (wrap.classList.contains('is-open')) wrap.querySelector('[data-vcd-note]')?.focus();
      });

      // Cart note save
      this.addEventListener('change', (e) => {
        const note = e.target.closest('[data-vcd-note]');
        if (!note) return;
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: note.value })
        });
      });

      // Direct qty input
      this.addEventListener('change', (e) => {
        const input = e.target.closest('[data-vcd-qty]');
        if (!input) return;
        const itemEl = input.closest('[data-vcd-item]');
        if (!itemEl) return;
        const qty = Math.max(0, parseInt(input.value || '0', 10));
        input.value = qty;
        this._changeQty(itemEl, qty);
      });

      // Remove
      this.addEventListener('click', (e) => {
        if (!e.target.closest('[data-vcd-remove]')) return;
        const itemEl = e.target.closest('[data-vcd-item]');
        if (!itemEl) return;
        this._changeQty(itemEl, 0, true);
      });
    }

    /* ===== AJAX cart update ===== */
    _changeQty(itemEl, qty, isRemove) {
      const variantId = itemEl.getAttribute('data-variant-id');
      if (!variantId) return;
      itemEl.style.opacity = '0.5';
      itemEl.style.pointerEvents = 'none';

      // Note: /cart/change.js regenerates line item keys when an order discount is applied
      // (Shopify recalculates discount allocation per item). /cart/update.js does not.
      // We use variant ID (not key) as the id to avoid stale-key 400 errors.
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: variantId, quantity: isRemove ? 0 : qty }),
      })
        .then((r) => r.json())
        .then((cart) => {
          if (isRemove || qty === 0) {
            itemEl.style.transform = 'translateX(12px)';
            itemEl.style.opacity = '0';
            setTimeout(() => {
              itemEl.remove();
              this._applyCart(cart);
            }, 200);
          } else {
            itemEl.style.opacity = '1';
            itemEl.style.pointerEvents = '';
            const unitCents = parseInt(itemEl.getAttribute('data-unit'), 10) || 0;
            const subEl = itemEl.querySelector('[data-vcd-subtotal]');
            if (subEl) subEl.textContent = this._money((unitCents * qty) / 100);
            this._applyCart(cart);
          }
        })
        .catch(() => {
          itemEl.style.opacity = '1';
          itemEl.style.pointerEvents = '';
        });
    }

    /* ===== Theme cart:update event (external add-to-cart) ===== */
    _onThemeCartUpdate(e) {
      if (this._locked) return;
      const apply = (cart) => {
        this._rebuildItems(cart);
        this._applyCart(cart);
        if (!this.classList.contains('vcd-open') && !e.detail?.noDrawer && !window.__vpNoDrawer) this.open();
      };
      // Use cart data from event detail when available (avoids a second network request)
      if (e.detail?.cart) { apply(e.detail.cart); return; }
      fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then((r) => r.json())
        .then(apply);
    }

    /* ===== Apply cart totals / freight bar ===== */
    _applyCart(cart) {
      const total = cart.total_price ?? 0;
      const itemCount = cart.item_count ?? 0;

      // Count pill
      const pill = this.querySelector('[data-vcd-count]');
      if (pill) pill.textContent = itemCount;

      // Total — show pre-discount amount (credit memos applied at checkout, not here)
      const totalEl = this.querySelector('[data-vcd-total]');
      if (totalEl) totalEl.textContent = this._money((cart.original_total_price ?? total) / 100);

      // Min order gate ($25)
      const checkoutBtn = this.querySelector('.vcd-checkout-btn[href]');
      const belowMin = (cart.original_total_price ?? total) < 2500;
      if (checkoutBtn) checkoutBtn.toggleAttribute('data-min-order', belowMin);

      // Footer visibility
      const footer = this.querySelector('[data-vcd-footer]');
      if (footer) footer.classList.toggle('vcd-footer--empty', itemCount === 0);

      // Freight bar
      if (this._freeShippingCents > 0) {
        const pct = Math.min(100, Math.round((total / this._freeShippingCents) * 100));
        const fill = this.querySelector('[data-vcd-freight-fill]');
        if (fill) fill.style.width = pct + '%';
        const msg = this.querySelector('[data-vcd-freight-msg]');
        if (msg) {
          if (total >= this._freeShippingCents) {
            msg.className = 'vcd-freight-msg vcd-freight-msg--met';
            msg.innerHTML = '&#x2713;&nbsp; You qualify for free shipping!';
          } else {
            const rem = this._freeShippingCents - total;
            msg.className = 'vcd-freight-msg';
            msg.innerHTML = `Add <strong data-vcd-freight-remaining>${this._money(rem / 100)}</strong> for free shipping`;
          }
        }
      }

      // Update theme header cart bubble (theme's own elements)
      document.querySelectorAll('[data-cart-count], .cart-bubble__text-count').forEach((el) => {
        el.textContent = itemCount > 99 ? '99+' : (itemCount || '');
        if (el.classList.contains('cart-bubble__text-count')) {
          el.dataset.cartCountValue = String(itemCount || 0);
          el.classList.toggle('hidden', itemCount === 0);
        }
      });
    }

    /* ===== Rebuild items list from /cart.js ===== */
    _rebuildItems(cart) {
      const wrap = this.querySelector('[data-vcd-items]');
      if (!wrap) return;

      if (!cart.items || cart.items.length === 0) {
        wrap.innerHTML = `
          <div class="vcd-empty" data-vcd-empty>
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" opacity="0.3"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>
            <p>Your cart is empty</p>
            <a href="/search?sort_by=relevance&q=*&filter.p.m.custom.product_designlab=0" class="vcd-empty-link">Start shopping</a>
          </div>`;
        return;
      }

      const existingBrands = new Map(
        Array.from(wrap.querySelectorAll('[data-vcd-item][data-key]')).map((el) => [
          el.dataset.key,
          el.dataset.brand || el.querySelector('.vcd-item-vendor')?.textContent?.trim() || '',
        ])
      );

      wrap.innerHTML = cart.items
        .map((item) => this._buildItemHtml({ ...item, _displayBrand: this._getItemBrand(item, false) || existingBrands.get(item.key) || item.vendor || '' }))
        .join('');
    }

    _buildItemHtml(item) {
      const isLow = this._lowStock > 0 && item.variant_inventory_quantity > 0 && item.variant_inventory_quantity <= this._lowStock;
      const variant = item.variant_title && item.variant_title !== 'Default Title'
        ? `<div class="vcd-item-variant">${this._esc(item.variant_title)}</div>` : '';
      const sku = item.sku ? `<div class="vcd-item-sku">${this._esc(item.sku)}</div>` : '';
      const brand = this._getItemBrand(item);
      const vendor = brand ? `<div class="vcd-item-vendor">${this._esc(brand)}</div>` : '';
      const img = item.image
        ? `<a href="${item.url}"><img src="${item.image}" alt="${this._esc(item.title)}" width="80" height="80" loading="lazy"></a>`
        : `<a href="${item.url}" class="vcd-thumb-placeholder"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" opacity="0.3"><rect x="3" y="3" width="18" height="18" rx="3"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg></a>`;

      return `<div class="vcd-item${isLow ? ' vcd-item--low' : ''}" data-vcd-item data-key="${item.key}" data-variant-id="${item.variant_id}" data-unit="${item.final_price}" data-brand="${this._esc(brand)}">
        <div class="vcd-item-thumb">${img}</div>
        <div class="vcd-item-info">
          ${vendor}
          <div class="vcd-item-name"><a href="${item.url}">${this._esc(item.product_title)}</a></div>
          ${variant}${sku}
        </div>
        <div class="vcd-item-right">
          <div class="vcd-item-top-row">
            <div class="vcd-item-sub" data-vcd-subtotal>${this._money(item.final_line_price / 100)}</div>
            <button class="vcd-remove-btn" data-vcd-remove aria-label="Remove ${this._esc(item.title)}">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M2 2l10 10M12 2 2 12"/></svg>
            </button>
          </div>
          <div class="vcd-item-qty">
            <button class="vcd-qty-btn" data-vcd-step="-1" aria-label="Decrease">&#x2212;</button>
            <input class="vcd-qty-input" type="number" value="${item.quantity}" min="0" data-vcd-qty aria-label="Quantity">
            <button class="vcd-qty-btn" data-vcd-step="1" aria-label="Increase">+</button>
          </div>
        </div>
      </div>`;
    }

    _getLineProperty(item, name) {
      const props = item?.properties;
      if (!props) return '';
      if (Array.isArray(props)) {
        const match = props.find((prop) => prop?.[0] === name || prop?.name === name || prop?.key === name);
        return match?.[1] || match?.value || '';
      }
      return props[name] || '';
    }

    _getItemBrand(item, includeVendor = true) {
      return item?._displayBrand || this._getLineProperty(item, '_brand') || item?.product_brand || (includeVendor ? item?.vendor : '') || '';
    }

    _money(amount) {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount);
    }

    _esc(str) {
      return String(str || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }
  }

  customElements.define('valor-cart-drawer', ValorCartDrawer);
})();

/* ── Rec strip custom elements (self-contained, no external deps) ── */
(function () {
  const _bagSvg = `<svg aria-hidden="true" width="14" height="14" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M16.608 9.421V6.906H3.392v8.016c0 .567.224 1.112.624 1.513.4.402.941.627 1.506.627H8.63M8.818 3h2.333c.618 0 1.212.247 1.649.686a2.35 2.35 0 0 1 .683 1.658v1.562H6.486V5.344c0-.622.246-1.218.683-1.658A2.33 2.33 0 0 1 8.82 3"/><path stroke="currentColor" stroke-linecap="round" stroke-width="1.5" d="M14.608 12.563v5m2.5-2.5h-5"/></svg>`;

  function _recMoney(cents, currency) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency', currency, minimumFractionDigits: 2,
    }).format(cents);
  }

  function _recBuildCard(p, currency) {
    const v = p.variants?.[0];
    // Recommendations API returns price as integer cents; Collections API returns dollar string (e.g. "8.00")
    const toAmt = n => n == null ? null : (typeof n === 'string' ? parseFloat(n) : n / 100);
    const priceAmt   = toAmt(v?.price);
    const compareAmt = toAmt(v?.compare_at_price);
    const price   = priceAmt != null ? _recMoney(priceAmt, currency) : '';
    const compare = compareAmt > priceAmt ? _recMoney(compareAmt, currency) : null;
    const raw = p.featured_image ?? p.images?.[0];
    const imgUrl = typeof raw === 'string' ? raw : raw?.src ?? '';
    const imgSrc = imgUrl ? imgUrl.replace(/\?.*$/, '') + '?width=220' : '';
    const url = `/products/${p.handle}`;
    const isMulti = (p.variants?.length ?? 1) > 1;
    const avail = v?.available !== false;
    const title = p.title.replace(/"/g, '&quot;');
    const addBtn = isMulti
      ? `<a href="${url}" class="vcd-rec-card__add" aria-label="View options">${_bagSvg}</a>`
      : (avail && v?.id ? `<button class="vcd-rec-card__add" data-rec-add data-variant-id="${v.id}" aria-label="Add to cart" type="button">${_bagSvg}</button>` : '');
    return `<div class="vcd-rec-card">
      <div class="vcd-rec-card__media">
        <a href="${url}" class="vcd-rec-card__img">
          ${imgSrc ? `<img src="${imgSrc}" alt="${title}" loading="lazy" width="110" height="110">` : ''}
          ${compare ? '<span class="vcd-rec-card__badge">Sale</span>' : ''}
        </a>${addBtn}
      </div>
      <div class="vcd-rec-card__info">
        <a href="${url}" style="text-decoration:none"><p class="vcd-rec-card__title">${p.title}</p></a>
        <p class="vcd-rec-card__price">${compare ? `<s class="vcd-rec-card__compare">${compare}</s> ` : ''}${price}</p>
      </div>
    </div>`;
  }

  async function _recAddVariant(variantId, btn) {
    if (!variantId || btn.disabled) return;
    btn.disabled = true; btn.dataset.state = 'loading';
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
      });
      if (!res.ok) throw new Error();
      const cart = await fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } }).then(r => r.json());
      btn.dataset.state = 'added';
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { cart, resource: cart } }));
      setTimeout(() => { delete btn.dataset.state; btn.disabled = false; }, 1500);
    } catch { delete btn.dataset.state; btn.disabled = false; }
  }

  if (!customElements.get('vcd-cart-rec')) {
    customElements.define('vcd-cart-rec', class extends HTMLElement {
      connectedCallback() {
        const { productId, currency = 'USD' } = this.dataset;
        const self = this;
        const fetchRec = productId
          ? fetch(`/recommendations/products.json?product_id=${productId}&limit=15`)
              .then(r => r.ok ? r.json() : Promise.reject())
              .then(({ products = [] }) => products)
          : Promise.resolve([]);
        // /collections API returns available: undefined (only variants have it); check both.
        const _avail = p => p.available === true || (Array.isArray(p.variants) && p.variants.some(v => v.available));

        /*
        // ── Original recommendation logic (contextual, based on last cart product) ──
        fetchRec
          .then(products => {
            if (products.length >= 15) return products;
            // Pad with recently viewed products
            let viewedIds = [];
            try { viewedIds = JSON.parse(localStorage.getItem('viewedProducts') || '[]'); } catch {}
            if (productId) viewedIds = viewedIds.filter(id => id.toString() !== productId.toString());
            const seen = new Set(products.map(p => p.id.toString()));
            const needed = viewedIds.filter(id => !seen.has(id.toString())).slice(0, 15 - products.length);
            if (!needed.length) return products;
            return fetch(`/search/suggest.json?q=${encodeURIComponent(needed.map(id => 'id:' + id).join(' OR '))}&resources[type]=product&resources[limit]=15`)
              .then(r => r.ok ? r.json() : { resources: {} })
              .then(data => {
                const found = data.resources?.results?.products ?? [];
                const ordered = needed.map(id => found.find(p => p.id.toString() === id.toString())).filter(p => p && _avail(p));
                return [...products, ...ordered];
              });
          })
        // ── End original recommendation logic ──
        */

        // Pick 3 guaranteed non-overlapping random pages from top 1500 best-sellers (50 pages × 30)
        const _pages = new Set();
        while (_pages.size < 3) _pages.add(Math.floor(Math.random() * 50) + 1);
        const [page1, page2, page3] = [..._pages];
        Promise.all([
          fetch(`/collections/all/products.json?limit=30&page=${page1}&sort_by=best-selling`).then(r => r.ok ? r.json() : { products: [] }),
          fetch(`/collections/all/products.json?limit=30&page=${page2}&sort_by=best-selling`).then(r => r.ok ? r.json() : { products: [] }),
          fetch(`/collections/all/products.json?limit=30&page=${page3}&sort_by=best-selling`).then(r => r.ok ? r.json() : { products: [] }),
        ])
          .then(([r1, r2, r3]) => {
            const seen = new Set();
            const unique = [];
            for (const p of [...(r1.products || []), ...(r2.products || []), ...(r3.products || [])]) {
              const id = p.id.toString();
              if (!seen.has(id) && _avail(p)) { seen.add(id); unique.push(p); }
            }
            return unique;
          })
          .then(products => {
            // Shuffle for random presentation
            for (let i = products.length - 1; i > 0; i--) {
              const j = Math.floor(Math.random() * (i + 1));
              [products[i], products[j]] = [products[j], products[i]];
            }
            if (!products.length) { self.closest('.vcd-rec')?.remove(); return; }
            self.innerHTML = products.map(p => _recBuildCard(p, currency)).join('');
          })
          .catch(() => self.closest('.vcd-rec')?.remove());
        this.addEventListener('click', e => {
          const btn = e.target.closest('[data-rec-add]');
          if (btn) { e.preventDefault(); _recAddVariant(btn.dataset.variantId, btn); }
        });
      }
    });
  }

  if (!customElements.get('vcd-cart-recent')) {
    customElements.define('vcd-cart-recent', class extends HTMLElement {
      connectedCallback() {
        const { excludeId, currency = 'USD' } = this.dataset;
        let ids = [];
        try { ids = JSON.parse(localStorage.getItem('viewedProducts') || '[]'); } catch {}
        if (excludeId) ids = ids.filter(id => id.toString() !== excludeId);
        if (!ids.length) { this._hideTab(); return; }
        ids = ids.slice(0, 15);
        fetch(`/search/suggest.json?q=${encodeURIComponent(ids.map(id => 'id:' + id).join(' OR '))}&resources[type]=product`)
          .then(r => r.ok ? r.json() : Promise.reject())
          .then(data => {
            const found = data.resources?.results?.products ?? [];
            const ordered = ids.map(id => found.find(p => p.id.toString() === id.toString())).filter(p => p && p.available !== false);
            if (!ordered.length) { this._hideTab(); return; }
            this.innerHTML = ordered.map(p => {
              const url = p.url;
              const imgSrc = p.image ? (p.image + (p.image.includes('?') ? '&' : '?') + 'width=220') : '';
              const title = p.title.replace(/"/g, '&quot;');
              const isMulti = (Number(p.variants_count) || 1) > 1;
              const addBtn = isMulti
                ? `<a href="${url}" class="vcd-rec-card__add" aria-label="View options">${_bagSvg}</a>`
                : `<button class="vcd-rec-card__add" data-rec-add-handle data-handle="${p.handle}" aria-label="Add to cart" type="button">${_bagSvg}</button>`;
              return `<div class="vcd-rec-card">
                <div class="vcd-rec-card__media">
                  <a href="${url}" class="vcd-rec-card__img">
                    ${imgSrc ? `<img src="${imgSrc}" alt="${title}" loading="lazy" width="110" height="110">` : ''}
                  </a>${addBtn}
                </div>
                <div class="vcd-rec-card__info">
                  <a href="${url}" style="text-decoration:none"><p class="vcd-rec-card__title">${p.title}</p></a>
                  <p class="vcd-rec-card__price">${p.price || ''}</p>
                </div>
              </div>`;
            }).join('');
          })
          .catch(() => this._hideTab());
        this.addEventListener('click', async e => {
          const btn = e.target.closest('[data-rec-add-handle]');
          if (!btn || btn.disabled) return;
          e.preventDefault();
          btn.disabled = true; btn.dataset.state = 'loading';
          try {
            const prod = await fetch(`/products/${btn.dataset.handle}.js`).then(r => r.json());
            const v = prod.variants?.[0];
            if (!v?.id || !v?.available) { window.location.href = `/products/${btn.dataset.handle}`; return; }
            btn.disabled = false;
            await _recAddVariant(String(v.id), btn);
          } catch { delete btn.dataset.state; btn.disabled = false; }
        });
      }
      _hideTab() {
        const tabBtn = document.getElementById('vcd-tab-btn-recent');
        const panel  = document.getElementById('vcd-tab-recent');
        if (tabBtn) {
          tabBtn.hidden = true;
          if (tabBtn.getAttribute('aria-selected') === 'true') document.getElementById('vcd-tab-btn-relate')?.click();
        }
        if (panel) { panel.hidden = true; panel.classList.remove('vcd-rec-panel--active'); }
      }
    });
  }

  if (!customElements.get('vcd-rec-tabs')) {
    customElements.define('vcd-rec-tabs', class extends HTMLElement {
      connectedCallback() {
        this.querySelectorAll('[role="tab"]').forEach(btn => {
          btn.addEventListener('click', () => {
            if (btn.getAttribute('aria-selected') === 'true') return;
            this.querySelectorAll('[role="tab"]').forEach(b => {
              b.setAttribute('aria-selected', 'false');
              b.classList.remove('is-active');
              const p = document.getElementById(b.getAttribute('aria-controls') ?? '');
              if (p) { p.hidden = true; p.classList.remove('vcd-rec-panel--active'); }
            });
            btn.setAttribute('aria-selected', 'true');
            btn.classList.add('is-active');
            const target = document.getElementById(btn.getAttribute('aria-controls') ?? '');
            if (target) { target.hidden = false; target.classList.add('vcd-rec-panel--active'); }
          });
        });
      }
    });
  }

  // Track quick view opens as recently viewed products
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('[data-quick-view-url]');
    if (!btn) return;
    const match = (btn.dataset.quickViewUrl || '').match(/\/products\/([^/?#]+)/);
    if (!match) return;
    fetch(`/products/${match[1]}.js`)
      .then(r => r.ok ? r.json() : null)
      .then(p => {
        if (!p?.id) return;
        try {
          const id = p.id.toString();
          let ids = JSON.parse(localStorage.getItem('viewedProducts') || '[]');
          ids = ids.filter(i => i !== id);
          ids.unshift(id);
          localStorage.setItem('viewedProducts', JSON.stringify(ids.slice(0, 16)));
        } catch {}
      });
  }, { capture: true });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["valor-nav-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
  /* Shared overlay singleton */
  function _getValorOverlay() {
    if (window.__valorDrawerOverlay) return window.__valorDrawerOverlay;
    const el = document.createElement('div');
    el.className = 'valor-drawer-overlay';
    document.body.appendChild(el);
    const ov = {
      el,
      _handler: null,
      show(onClose) {
        el.classList.add('valor-open');
        if (this._handler) el.removeEventListener('click', this._handler);
        this._handler = () => { this.hide(); onClose && onClose(); };
        el.addEventListener('click', this._handler, { once: true });
      },
      hide() {
        el.classList.remove('valor-open');
        if (this._handler) { el.removeEventListener('click', this._handler); this._handler = null; }
      },
    };
    return (window.__valorDrawerOverlay = ov);
  }

  class ValorMenuDrawer extends HTMLElement {
    connectedCallback() {
      /* The drawer renders inside the desktop nav section, which is hidden on
         mobile — a hidden ancestor collapses a fixed element to 0x0. Move to
         <body> first; the re-append re-runs connectedCallback with the new
         parent, and init happens exactly once. */
      if (this.parentElement !== document.body) {
        document.body.appendChild(this);
        return;
      }
      if (this._vmdInit) return;
      this._vmdInit = true;
      this._initTabs();
      this._initAccordions();
      this._initOpen();
    }

    _initOpen() {
      /* Trigger from header hamburger button */
      document.addEventListener('vmd:open-menu', () => this.open());

      /* Close button inside drawer */
      this.querySelector('[data-vmd-close]')?.addEventListener('click', () => this.close());

      /* Register link → open popup instead of redirecting */
      this.querySelector('.vmd-account-card__register')?.addEventListener('click', (e) => {
        e.preventDefault();
        this.close();
        setTimeout(() => document.dispatchEvent(new CustomEvent('vr:open-register')), 0);
      });

      /* Escape key */
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.classList.contains('vmd-open')) this.close();
      });
    }

    open() {
      this.classList.add('vmd-open');
      document.body.classList.add('vcd-scroll-locked');
      _getValorOverlay().show(() => this.close());
    }

    close() {
      this.classList.remove('vmd-open');
      document.body.classList.remove('vcd-scroll-locked');
      _getValorOverlay().hide();
      const trigger = document.querySelector('[data-vmd-trigger]');
      trigger?.setAttribute('aria-expanded', 'false');
      trigger?.focus();
    }

    _initTabs() {
      const tabs = this.querySelectorAll('[data-vmd-tab]');
      const panels = this.querySelectorAll('[data-vmd-panel]');
      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const target = tab.dataset.vmdTab;
          tabs.forEach((t) => {
            t.classList.remove('vmd-tab--active');
            t.setAttribute('aria-selected', 'false');
          });
          panels.forEach((p) => {
            const active = p.dataset.vmdPanel === target;
            p.hidden = !active;
            p.classList.toggle('vmd-panel--active', active);
          });
          tab.classList.add('vmd-tab--active');
          tab.setAttribute('aria-selected', 'true');
          const body = this.querySelector('.vmd-body');
          if (body) body.scrollTop = 0;
        });
      });
    }

    _initAccordions() {
      this.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-vmd-acc]');
        if (!btn) return;
        const item = btn.closest('[data-vmd-acc-item]');
        if (!item) return;
        const wasOpen = item.classList.contains('vmd-acc--open');
        const panel = btn.closest('[data-vmd-panel]');
        if (panel) {
          panel.querySelectorAll('[data-vmd-acc-item].vmd-acc--open').forEach((el) => {
            el.classList.remove('vmd-acc--open');
            const subs = el.querySelector('.vmd-acc-subs');
            if (subs) subs.style.maxHeight = '0';
            const b = el.querySelector('[data-vmd-acc]');
            if (b) b.setAttribute('aria-expanded', 'false');
          });
        }
        if (!wasOpen) {
          item.classList.add('vmd-acc--open');
          btn.setAttribute('aria-expanded', 'true');
          const subs = item.querySelector('.vmd-acc-subs');
          if (subs) subs.style.maxHeight = subs.scrollHeight + 'px';
        }
      });
    }
  }

  if (!customElements.get('valor-menu-drawer')) {
    customElements.define('valor-menu-drawer', ValorMenuDrawer);
  }
})();

// Drawer-close on shopify-account click disabled for testing — re-enable if dialog appears behind drawer
// (function () {
//   document.addEventListener('click', function (e) {
//     if (!e.target.closest('shopify-account.vmd-account-sa')) return;
//     var drawer = document.querySelector('valor-menu-drawer.vmd-open');
//     if (drawer && typeof drawer.close === 'function') drawer.close();
//   });
// })();

// B2B account card: populate company name, market, and avatar initials from cached customer-info
(function () {
  var nameEl   = document.getElementById('vmd-account-card-name');
  var marketEl = document.getElementById('vmd-account-card-market');
  var avatarEl = document.getElementById('vmd-account-avatar');
  if (!nameEl && !marketEl) return;
  function applyInfo(d) {
    var company = d.name || d.Name || '';
    var handle  = d.shopifyMarketHandle || '';
    if (company && nameEl)  nameEl.textContent  = company;
    if (handle  && marketEl) marketEl.textContent = handle.toLowerCase().replace(/[-_]/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
  }
  if (window.__vaCustomerInfo) window.__vaCustomerInfo.then(function (d) { if (d) applyInfo(d); });
})();
  } catch(e) { console.error(e); }
})();

})();
